import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import Email from '@/components/Email';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/email',
            name: 'Email',
            component: Email,
            meta: { requiresAuth: true }
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js